import React from "react"

export default function AgeRangeSelector({
  ageRanges,
  selectedAgeRange,
  usedAgeRangesForGender,
  onToggle,
  onSelectAll,
}) {
  const selectableCount = ageRanges.length - usedAgeRangesForGender.size
  const allSelectableSelected =
    selectableCount > 0 &&
    ageRanges.every(
      (r) => usedAgeRangesForGender.has(r.value) || selectedAgeRange.includes(r.value)
    )

  return (
    <div className="ai-targeting-form__field">
      <div className="ai-targeting-form__field-header">
        <div className="ai-targeting-form__field-icon">
          <i className="fas fa-child"></i>
        </div>
        <label className="ai-targeting-form__field-label">Tranches d'âge ciblées</label>
        <button
          type="button"
          className="ai-targeting-form__select-all-btn"
          onClick={onSelectAll}
          disabled={selectableCount === 0}
        >
          {allSelectableSelected ? "Tout désélectionner" : "Tout sélectionner"}
        </button>
      </div>

      {usedAgeRangesForGender.size > 0 && (
        <div className="ai-targeting-form__warning">
          <i className="fas fa-info-circle"></i>
          <span>
            Les tranches grisées sont déjà utilisées par d'autres ressources pour ce genre.
          </span>
        </div>
      )}

      <div className="ai-targeting-form__age-chips">
        {ageRanges.map((range) => {
          const isDisabled = usedAgeRangesForGender.has(range.value)
          const isSelected = selectedAgeRange.includes(range.value)
          return (
            <button
              key={range.value}
              type="button"
              className={`ai-targeting-form__age-chip ${isSelected ? "ai-targeting-form__age-chip--active" : ""
                } ${isDisabled ? "ai-targeting-form__age-chip--disabled" : ""}`}
              disabled={isDisabled}
              onClick={() => onToggle(range.value)}
              title={
                isDisabled ? "Déjà utilisée par une autre ressource pour ce genre" : undefined
              }
            >
              {range.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
